import React, { useState } from 'react';
import VersionDisplay from './VersionDisplay';
import PrivacyPolicy from '../Legal/PrivacyPolicy';
import TermsOfService from '../Legal/TermsOfService';
import FAQ from '../Help/FAQ';
import './Footer.css';

const Footer = ({ isViewMode = false }) => {
  const [showPrivacy, setShowPrivacy] = useState(false);
  const [showTerms, setShowTerms] = useState(false);
  const [showFAQ, setShowFAQ] = useState(false);

  // Only show footer in view mode or when explicitly needed
  if (!isViewMode) {
    return null;
  }

  return (
    <>
      <footer className="app-footer">
        <div className="footer-content">
          <div className="footer-left">
            <VersionDisplay />
          </div>
        </div>
      </footer>

      {showPrivacy && (
        <PrivacyPolicy onClose={() => setShowPrivacy(false)} />
      )}
      
      {showTerms && (
        <TermsOfService onClose={() => setShowTerms(false)} />
      )}
      
      {showFAQ && (
        <FAQ onClose={() => setShowFAQ(false)} />
      )}
    </>
  );
};

export default Footer;